export default "__VITE_ASSET__CHU66ItY__"